import { baseURLPublic } from '../../config/BaseUrl';

export function requestKey() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const fallbackSessions = new Map();
export function activitySession(token) {
  const key = `sg-activity-session:${token}`;
  try {
    let value = sessionStorage.getItem(key);
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '')) {
      value = requestKey(); sessionStorage.setItem(key, value);
    }
    return value;
  } catch (error) {
    if (!fallbackSessions.has(token)) fallbackSessions.set(token, requestKey());
    return fallbackSessions.get(token);
  }
}

export function trackLeadAction(token, name, key) {
  try {
    const session = activitySession(token);
    const payload = { name, session_key: session, request_key: key || (name === 'social_gallery_opened' ? session : requestKey()) };
    const path = `social-gallery-v2/links/${encodeURIComponent(token)}/activity`;
    if (window.fetch && baseURLPublic.defaults?.baseURL) {
      return window.fetch(new URL(path, baseURLPublic.defaults.baseURL).href, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        keepalive: true, credentials: 'omit', referrerPolicy: 'no-referrer',
      }).catch(() => {});
    }
    return baseURLPublic.post(path, payload).catch(() => {});
  } catch (error) { return Promise.resolve(); } // Analytics never blocks media or a lead action.
}
